import { StringValues } from '../interfaces/undetermined';

// Constante que guarda el nombre de los atributos que recibe el API de reportes, segun nombre en los formularios
export const RISKS: StringValues = {
    amortization: "amortization",
    concept: "concept",
    operation: "ope",
    value: "value",
    codes: "codes",
    date: "date",
};
